var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    { staticClass: "pagination pagination-sm" },
    [
      _c(
        "li",
        { class: ["first", { disabled: !_vm.prevEnabled || _vm.disabled }] },
        [
          _vm.prevEnabled
            ? _c(
                "a",
                {
                  attrs: { role: "button", title: "first" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.minPage)
                    },
                  },
                },
                [_vm._v("«")]
              )
            : _c("span", { attrs: { title: "first" } }, [_vm._v("«")]),
        ]
      ),
      _vm.prevEnabled
        ? _c(
            "li",
            { class: ["prev", { disabled: !_vm.prevEnabled || _vm.disabled }] },
            [
              _c(
                "a",
                {
                  attrs: { role: "button", title: "previous" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.page - 1)
                    },
                  },
                },
                [_vm._v("‹")]
              ),
            ]
          )
        : _vm._e(),
      _vm.showOffsets
        ? _vm._l(_vm.lowerPages, function (i) {
            return _c("li", { key: i, class: { disabled: _vm.disabled } }, [
              _c(
                "a",
                {
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(i)
                    },
                  },
                },
                [_vm._v(_vm._s((i + 1).toLocaleString()))]
              ),
            ])
          })
        : _vm._e(),
      _c(
        "li",
        {
          class: {
            current: _vm.pageActive,
            active: _vm.pageActive,
            disabled: _vm.disabled,
          },
        },
        [
          _vm.editable && !_vm.hasPageRange
            ? [
                _c("input", {
                  ref: "maincontrol",
                  staticClass: "form-control",
                  attrs: { type: "number", disabled: _vm.disabled },
                  domProps: { value: _vm.page + 1 },
                  on: {
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      _vm.isValid($event.target.value - 1)
                        ? _vm.changePage($event.target.value - 1)
                        : ($event.target.value = _vm.page + 1)
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      $event.target.value = _vm.page + 1
                      $event.target.blur()
                    },
                    change: function ($event) {
                      $event.preventDefault()
                      _vm.isValid($event.target.value - 1)
                        ? _vm.changePage($event.target.value - 1)
                        : ($event.target.value = _vm.page + 1)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.editable
                  ? _c("span", { staticClass: "fa fa-pencil" })
                  : _vm._e(),
              ]
            : !_vm.pageActive
            ? _c(
                "a",
                {
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.page)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.currentPageLabel))]
              )
            : _c("span", [_vm._v(_vm._s(_vm.currentPageLabel))]),
        ],
        2
      ),
      _vm.showOffsets
        ? _vm._l(_vm.higherPages, function (i) {
            return _c("li", { key: i, class: { disabled: _vm.disabled } }, [
              _c(
                "a",
                {
                  attrs: { role: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(i)
                    },
                  },
                },
                [_vm._v(_vm._s((i + 1).toLocaleString()))]
              ),
            ])
          })
        : _vm._e(),
      _vm.nextEnabled
        ? _c(
            "li",
            { class: ["next", { disabled: !_vm.nextEnabled || _vm.disabled }] },
            [
              _c(
                "a",
                {
                  attrs: { role: "button", title: "next" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.page + 1)
                    },
                  },
                },
                [_vm._v("›")]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "li",
        { class: ["last", { disabled: !_vm.nextEnabled || _vm.disabled }] },
        [
          _vm.nextEnabled
            ? _c(
                "a",
                {
                  attrs: {
                    role: "button",
                    title: (_vm.maxPage + 1).toLocaleString() + " (last)",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(_vm.maxPage)
                    },
                  },
                },
                [_vm._v("»")]
              )
            : _c(
                "span",
                {
                  attrs: {
                    title: (_vm.maxPage + 1).toLocaleString() + " (last)",
                  },
                },
                [_vm._v("»")]
              ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }